const items = [
    "CONSULTORÍA E IMPLEMENTACIÓN DE IA",
    "ACELERACIÓN COMERCIAL",
    "SDR EXTERNO Y PROSPECCIÓN B2B",
    "DIRECCIÓN EMPRESARIAL Y LIDERAZGO",
    "CAIO EXTERNO — DIRECCIÓN DE IA",
    "REVENUE. ENGINEERED.",
    "SOCIOS A LARGO PLAZO",
];

export default function Marquee() {
    const row = [...items, ...items];
    return (
        <div
            data-testid="marquee-strip"
            className="overflow-hidden border-y border-brand-line bg-brand-soft py-5"
        >
            <div className="flex gap-14 animate-marquee whitespace-nowrap will-change-transform">
                {row.map((t, i) => (
                    <span
                        key={i}
                        className="label-mono !text-brand-gray !text-[11px] flex items-center gap-14"
                    >
                        {t}
                        <span className="w-1 h-1 bg-brand-gray/40 inline-block" />
                    </span>
                ))}
            </div>
        </div>
    );
}
